import { Text } from '@eo-locale/react';
import type { FC } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { AuthApi } from '../../api';
import { useApiErrorHandler } from '../../hooks';
import { Button } from '../atoms';
import { Input } from '../atoms/Input';
import type { LoginFormFields } from './LoginForm';
import styles from './LoginForm.module.css';
import { useToast } from '../../components/atoms/Toast';
import axios from 'axios';

interface Props {
  onSuccess(): void;
}

export const LoginMembershipID: FC<Props> = ({ onSuccess }) => {
  const { handleSubmit, setError } = useFormContext<LoginFormFields>();
  const handleApiError = useApiErrorHandler(setError);
  const { toast } = useToast();

  const onSubmit: SubmitHandler<LoginFormFields> = async ({ membershipId }) => {
    try {
      await AuthApi.requestOtp(membershipId);
      onSuccess();
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.data?.message) {
        const errorMessage = error.response.data.message;
        setError('membershipId', {
          type: 'validate',
          message: errorMessage
        });
        toast({
          variant: 'error',
          description: errorMessage
        });
      } else {
        handleApiError(error);
      }
    }
  };

  return (
    <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
      <Input
        block
        className={styles.membershipId}
        name="membershipId"
        label="personal_data:id"
        type="number"
      />
      <Button className={styles.submit}>
        <Text id="login:send_code" />
      </Button>
      <p className='mt-4 text-white'>
        <Text id="login:email_step_subtitle" />
      </p>
    </form>
  );
};
